export default __webpack_public_path__ + "14aa7d1703bad0a4b7036a2d57f9c630.svg";